import React, { useState, useMemo } from "react";
import stylesCommon from "@/styles/detail/DetailBookingSidebar/DetailBookingConfigurator.module.scss";
import generalSvg from "@/utils/svg-icon/general";
import socialAndBrandSvg from "@/utils/svg-icon/socialAndBrand";
import styles from "@/styles/detail/DetailBookingSidebar/ChooseExperienceSectionDetail.module.scss";
import { useIsSM } from "@/utils/hooks/useWindowSizes";
import { useCurrency } from "@/utils/hooks/useCurrency";
import { useCurrencyConversion } from "@/utils/hooks/useCurrencyConversion";
import { getCurrencySymbol } from "@/utils/common/formatPrice";

const ChooseExperienceSectionDetail = ({
    isPremium,
    setIsPremium,
    pricePremium,
    priceQuality,
}: {
    isPremium: boolean;
    setIsPremium: (el: boolean) => void;
    pricePremium: number;
    priceQuality: number;
}) => {
    const { Star } = generalSvg;
    const { SketchLine } = socialAndBrandSvg;
    const isSM = useIsSM();
    const { currency } = useCurrency();
    const { convertPrice } = useCurrencyConversion();

    // Calcola la differenza di prezzo (in EUR) e converte nella valuta selezionata
    const { roundedDifference, currencySymbol } = useMemo(() => {
        const differencePriceEUR =
            pricePremium - priceQuality >= 0
                ? pricePremium - priceQuality
                : priceQuality - pricePremium;

        // Converte la differenza nella valuta selezionata
        const differencePriceConverted = parseFloat(
            convertPrice(differencePriceEUR)
        );

        return {
            roundedDifference: Math.round(differencePriceConverted),
            currencySymbol: getCurrencySymbol(currency),
        };
    }, [pricePremium, priceQuality, currency, convertPrice]);

    const [showPrice, setShowPrice] = useState<"quality" | "premium" | null>(
        null
    );

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className={stylesCommon.configuratorTitle}>
                    Choose your Experience
                </h3>
            </div>
            <p className={stylesCommon.configuratorDescription}>
                We both offer a Quality and Premium version for our trips. Based
                on your preference, choose your favorite formula.
            </p>
            <div className={styles.buttonContainer}>
                <div
                    className={
                        !isPremium
                            ? styles.buttonActiveQuality
                            : styles.buttonDefaultQuality
                    }
                    onClick={() => {
                        setIsPremium(false);
                        // const url = new URL(window.location.href);
                        // url.searchParams.set(
                        //     "isPremium",
                        //     !isPremium as unknown as string
                        // );
                        // window.history.replaceState(null, "", url);
                        setShowPrice(null);
                    }}
                    onMouseEnter={() => isPremium && setShowPrice("quality")}
                    onMouseLeave={() => isPremium && setShowPrice(null)}
                >
                    {(showPrice === "quality" || (isSM && isPremium)) && (
                        <span className={styles.differencePriceQuality}>
                            {pricePremium - priceQuality >= 0 ? "-" : "+"}
                            {currencySymbol}
                            {roundedDifference}
                        </span>
                    )}
                    <span className="me-2">Quality</span>
                    <div className={styles.iconQuality}>
                        <Star />
                    </div>
                </div>
                <div
                    className={
                        isPremium
                            ? styles.buttonActivePremium
                            : styles.buttonDefaultPremium
                    }
                    onClick={() => {
                        setIsPremium(true);
                        // const url = new URL(window.location.href);
                        // url.searchParams.set(
                        //     "isPremium",
                        //     !isPremium as unknown as string
                        // );
                        // window.history.replaceState(null, "", url);
                        setShowPrice(null);
                    }}
                    onMouseEnter={() => !isPremium && setShowPrice("premium")}
                    onMouseLeave={() => !isPremium && setShowPrice(null)}
                >
                    {(showPrice === "premium" || (isSM && !isPremium)) && (
                        <span className={styles.differencePricePremium}>
                            {pricePremium - priceQuality >= 0 ? "+" : "-"}
                            {currencySymbol}
                            {roundedDifference}
                        </span>
                    )}
                    <span className="me-2">Premium</span>
                    <div className={styles.iconPremium}>
                        <SketchLine />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChooseExperienceSectionDetail;
